export default __webpack_public_path__ + "static/media/lumen-courtesy-message.36971a4d.svg";